import React from 'react';
import { Link } from 'react-router-dom';
import './AppHome.css';

const features = [
  {
    title: 'Q&A',
    description: 'Get instant answers to your NEET questions with our AI-powered question and answer system.',
    icon: '❓'
  },
  {
    title: 'Summarize',
    description: 'Quickly summarize long chapters and topics to focus on key concepts for your NEET preparation.',
    icon: '📝'
  },
  {
    title: 'Notes Maker',
    description: 'Create organized, personalized study notes with AI assistance to enhance your learning experience.',
    icon: '📚'
  }
];

export default function AppHome() {
  const handleSignUp = () => {
    window.open('https://play.google.com/store/apps/details?id=com.devkaran.ai&hl=en_IN', '_blank');
  };

  return (
    <div className="app-home">
      <div className="hero-section">
        <div className="app-logo">
          <img src={process.env.PUBLIC_URL + '/k2.png'} alt="K2 NEET" className="logo-image" />
        </div>
        <h1 className="app-title">K2 NEET</h1>
        <p className="app-subtitle">AI-powered NEET preparation</p>
      </div>

      <div className="signup-section">
        <div className="signup-card">
          <h2 className="signup-title">🚀 Get Free Early Access!</h2>
          <p className="signup-description">
            Sign up now to get free early access to our AI-powered NEET preparation platform. No payment required!
          </p>
          <button className="signup-button" onClick={handleSignUp}>
            Download now for free!
          </button>
          <p className="signup-note">Join our list of students to experience K2 NEET - completely free!</p>
        </div>
      </div>

      <div className="features-section">
        <h2 className="features-title">Key Features</h2>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>

      <footer className="footer">
        <div className="footer-links">
          <Link to="/privacy" className="footer-link">
            Privacy Policy
          </Link>
          <Link to="/terms" className="footer-link">
            Terms of Service
          </Link>
        </div>
      </footer>
    </div>
  );
} 